export default "__VITE_ASSET__BqKfGwVF__"